module.exports = __webpack_public_path__ + "img/mas icon.7c3c3219.svg";